import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TccTrackingService {

  private BASE_URL:string = window["cfgApiBaseUrl"];
  private TCC_TRACKING_URL:string = this.BASE_URL+"tracking/";

  constructor(private http : HttpClient) { }

  getTccStatus(tccno:string):Observable<string[]>{
    return this.http.get<any>(this.TCC_TRACKING_URL+tccno);
  }
}
